import { render, staticRenderFns } from "./IsExtraSmall.vue?vue&type=template&id=e7e1babc"
import script from "./IsExtraSmall.vue?vue&type=script&lang=js"
export * from "./IsExtraSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports